import React, { useEffect, useState, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputNumber } from 'primereact/inputnumber';
import { FaSpinner } from 'react-icons/fa';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import AutoCompleteLote from './AutoCompleteLote';
import ModalAlmoxarifado from './ModalAlmoxarifado';
import { dominioBackend } from '../../config/database';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'assets/scss/prime-table.scss';
import 'assets/css/prime-table.css';

export default function ModalAtender({ openDialogAtender, closeDialogAtender, requisicao }) {
  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDialogAlmoxarifado, setOpenDialogAlmoxarifado] = useState(false);
  const profissional = JSON.parse(localStorage.getItem('profissional'));
  const myToast = useRef(null);

  useEffect(() => {
    if (requisicao) setProdutos(requisicao.produtos);
  }, [requisicao]);

  const renderFooterDisplay = () => {
    return (
      <div>
        <Button
          color="#28a745"
          type="button"
          onClick={() => setOpenDialogAlmoxarifado(true)}
          className={profissional.duplicaRequisicao ? '' : 'invisivel'}
        >
          Duplicar
        </Button>
        <Button color="#28a745" type="submit">
          {loading ? <FaSpinner color="#FFF" className="loading" size={14} /> : <>Atender</>}
        </Button>
      </div>
    );
  };

  const renderHeaderDisplay = () => {
    return (
      <div>
        <span>
          {`Atender requisição Nº ${requisicao.numero} ${requisicao.requisicaoPai ? `(${requisicao.requisicaoPai.numero})` : ''
            }`}
        </span>

        <div style={{ display: 'flex', marginTop: 16 }}>
          <span>
            {requisicao.tipoRequisicao === 'S'
              ? 'Tipo Req.: Saída'
              : requisicao.tipoRequisicao === 'D'
                ? 'Tipo Req.: Devolução'
                : 'Tipo Req.: Não informado'}
          </span>
          <span style={{ marginLeft: 32 }}>
            {requisicao.ramal ? `Ramal: ${requisicao.ramal}` : 'Ramal: Não informado'}
          </span>
          <span style={{ whiteSpace: 'normal', wordBreak: 'break-word', marginLeft: 32 }}>
            {requisicao.setorRequisitante
              ? `Setor Requisitante: ${requisicao.setorRequisitante}`
              : 'Setor Requisitante: Não informado'}
          </span>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: 16 }}>
          <span style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
            {requisicao.observacao ? `Obs: ${requisicao.observacao}` : 'Obs.: Não informado'}
          </span>
        </div>
      </div>
    );
  };

  const codigoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Código</span>
        <span>{rowData.codigo}</span>
      </>
    );
  };

  const nomeBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Nome</span>
        {rowData.nome}
        {rowData.informacaoAdicional && ` - ${rowData.informacaoAdicional.toUpperCase()}`}
      </>
    );
  };

  const qtdSolicitadaBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Quantidade Pedida</span>
        <span>{rowData.quantidadeRequisitada}</span>
      </>
    );
  };

  const onQuantidadeAtendidaChange = (rowData, value) => {
    const listaProdutos = produtos;
    const produtoIndex = listaProdutos.findIndex(p => p.id === rowData.id);
    listaProdutos[produtoIndex].quantidadeAtendida = value;
    setProdutos(listaProdutos);
  };

  const quantidadeAtendidaEditor = props => {
    return (
      <InputNumber
        value={props.rowData.quantidadeAtendida}
        onChange={e => onQuantidadeAtendidaChange(props.rowData, e.value)}
      />
    );
  };

  const quantidadeAtendidaBodyTemplate = rowData => {
    return (
      <InputNumber
        required
        value={rowData.quantidadeAtendida}
        onChange={e => onQuantidadeAtendidaChange(rowData, e.value)}
      />
    );
  };

  const onLoteChange = (rowData, value) => {
    const listaProdutos = produtos;
    const produtoIndex = listaProdutos.findIndex(p => p.id === rowData.id);
    listaProdutos[produtoIndex].lote = value;
    setProdutos(listaProdutos);
  };

  const loteEditor = props => {
    return (
      <>
        {/* <AutoCompleteLote
          idProduto={props.rowData.idProduto}
          onLoteChange={onLoteChange}
          propsRow={props.rowData}
          myToast={myToast}
        /> */}
      </>
    );
  };

  const loteBodyTemplate = rowData => {
    return (
      <>
        {rowData.temLote === true ? (
          // <InputText
          //   required
          //   value={rowData.lote ? rowData.lote.codigo : ''}
          //   onChange={e => onLoteChange(rowData, e.value)}
          // />
          <span>{rowData.lote ? rowData.lote.codigo : ''}</span>
        ) : (
          <></>
        )}
      </>
    );
  };

  const saldoProdutoBodyTemplate = rowData => {
    return (
      <>
        {!rowData.temLote ? (
          <>
            <span className="p-column-title">Saldo do Produto</span>
            <span>{rowData.saldoProduto}</span>
          </>
        ) : (
          <></>
        )}
      </>
    );
  };

  const onSubmit = e => {
    e.preventDefault();

    const data = {
      produtos,
    };
    setLoading(true);
    dominioBackend.put(`/api/atenderRequisicao/${requisicao.id}/${profissional.userId}`, data).then(
      async () => {
        myToast.current.show({
          severity: 'success',
          summary: 'Sucesso!',
          detail: 'Requisição atendida com sucesso!',
          life: '3000',
        });

        dominioBackend.get(`/api/exportarAtendimentoRequisicao/${requisicao.id}`);

        dominioBackend.put(`/api/entregarRequisicao/${requisicao.id}/${profissional.userId}`).then(
          () => {
            myToast.current.show({
              severity: 'success',
              summary: 'Sucesso!',
              detail: 'Requisição entregue com sucesso!',
              life: '3000',
            });
          },
          () => {
            myToast.current.show({
              severity: 'warn',
              summary: 'Atenção!',
              detail: `Erro ao entregar requisição!`,
              life: '3000',
            });
          }
        );

        /* Chamado: 2026050241 - removido abrir impressao de boletim de entrega */
        await dominioBackend().then(promise => {
          window.open(`${promise.config.baseURL}/boletimEntrega/${requisicao.id}`);
        });
        setLoading(false);
        closeDialogAtender();
      },
      () => {
        setLoading(false);
        myToast.current.show({
          severity: 'warn',
          summary: 'Atenção!',
          detail: `Erro ao atender requisição!`,
          life: '3000',
        });
      }
    );
  };

  return (
    <>
      <Toast ref={myToast} />
      {requisicao ? (
        <>
          <Dialog
            header="Selecione o almoxarifado"
            visible={openDialogAlmoxarifado}
            style={{ width: '45vw' }}
            onHide={() => setOpenDialogAlmoxarifado(false)}
          >
            <ModalAlmoxarifado
              idRequisicao={requisicao.id}
              myToast={myToast}
              setOpenDialogAlmoxarifado={setOpenDialogAlmoxarifado}
            />
          </Dialog>
          <form onSubmit={onSubmit}>
            <Dialog
              header={renderHeaderDisplay()}
              visible={openDialogAtender}
              style={{ width: '65vw' }}
              footer={renderFooterDisplay()}
              onHide={() => closeDialogAtender()}
            >
              <div className="datatable">
                <DataTable
                  value={produtos}
                  editMode="cell"
                  rows={5}
                  paginator
                  className="p-datatable-prime"
                >
                  <Column field="codigo" body={codigoBodyTemplate} header="Código" sortable />
                  <Column field="nome" body={nomeBodyTemplate} header="Nome" sortable />
                  <Column
                    field="quantidadeRequisitada"
                    body={qtdSolicitadaBodyTemplate}
                    header="Quantidade Pedida"
                    sortable
                  />
                  {/* <Column
                    field="quantidadeAtendida"
                    header="Quantidade Atendida"
                    body={quantidadeAtendidaBodyTemplate}
                    editor={props => quantidadeAtendidaEditor(props)}
                  /> */}
                  <Column
                    field="lote"
                    header="Lote"
                    body={loteBodyTemplate}
                    editor={props => (props.rowData.temLote ? loteEditor(props) : null)}
                  />
                  {/* Chamado  2021080039 */}
                  <Column
                    field="saldoProduto"
                    header="Saldo do Produto"
                    body={saldoProdutoBodyTemplate}
                  />
                </DataTable>
              </div>
            </Dialog>
          </form>
        </>
      ) : null}
    </>
  );
}
